import React from 'react';

const ColorDropdown = ({
    colors,
    selectedColor,
    onSelect,
    googleColor,
}: {
    colors: { ColorCode: string; Name?: string }[];
    selectedColor?: string;
    onSelect: (color: string) => void;
    googleColor: string;
}) => {
    const displayColor =
        googleColor !== ''
            ? googleColor
            : selectedColor || (colors.length > 0 ? colors[0].ColorCode : '#fff');

    return (
        <div className="dropdown">
            <button
                className="btn d-flex align-items-center justify-content-center shadow-sm px-1 py-3"
                style={{
                    minWidth: 50,
                    height: 20,
                    backgroundColor: '#eee',
                    border: '1px solid #eee',
                    borderRadius: '0.42rem'
                }}
                data-bs-toggle="dropdown"
            >
                <span
                    className="rounded-circle border me-2"
                    style={{
                        width: 10,
                        height: 10,
                        marginLeft: '4px',
                        backgroundColor: displayColor,
                        boxShadow: '0 0 3px rgba(0,0,0,0.3)',
                    }}
                ></span>
                <i className="ki-outline ki-down fs-7"></i>
            </button>

            <ul className="dropdown-menu p-3 shadow-lg" style={{ minWidth: 80 }}>
                <div className="d-flex flex-wrap">
                    {colors.map((c, idx) => (
                        <li key={idx} className="list-unstyled">
                            <button
                                type="button"
                                className={`m-1 rounded-circle border position-relative ${c.ColorCode === displayColor ? 'border-dark border-2' : ''
                                    }`}
                                style={{
                                    width: 20,
                                    height: 20,
                                    backgroundColor: c.ColorCode,
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                title={c?.Name || c.ColorCode}
                                onClick={() => onSelect(c.ColorCode)}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            >
                                {c.ColorCode === displayColor && (
                                    <span
                                        className="position-absolute top-50 start-50 translate-middle"
                                        style={{ fontSize: 14, color: '#fff', textShadow: '0 0 3px black' }}
                                    >
                                        ✓
                                    </span>
                                )}
                            </button>
                        </li>
                    ))}
                </div>
            </ul>
        </div>
    );
};

export default ColorDropdown;
